import { useSetOrganizationStatus } from './useOrganizationMutations';

/** Alias — kolumny tabeli wołają starą nazwę. */
export const usePatchOrganizationStatus = useSetOrganizationStatus;
